import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DoggyhubPageRoutingModule } from './doggyhub-routing.module';

import { DoggyhubPage } from './doggyhub.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DoggyhubPageRoutingModule
  ],
  declarations: [DoggyhubPage]
})
export class DoggyhubPageModule {}
